module.exports = __webpack_public_path__ + "img/appstore.c1c98645.svg";